import ConstrollIcon from './component'

export default ConstrollIcon
